"use client";

import * as React from "react";

interface IPropTypes extends React.SVGAttributes<SVGElement> {
  color?: string;
}

export const CautionCircle: React.FunctionComponent<IPropTypes> = ({
  color = "#ff6d6d",
  ...props
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="https://www.w3.org/2000/svg"
    {...props}
  >
    <title>Group Copy</title>
    <g transform="translate(.5 .333)" fill="none" fillRule="evenodd">
      <path fill={color} fillRule="nonzero" d="M7 5h1v4.138H7zM7 10h1v1H7z" />
      <circle stroke={color} cx="7.5" cy="7.667" r="7" />
    </g>
  </svg>
);
